import React from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
});

export const Wrapper: React.FC = ({ children }) => {
  const classNames = useStyles();

  return (
    <Container maxWidth="xl" className={classNames.wrapper}>
      {React.Children.toArray(children)}
    </Container>
  );
};
